import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconSiteMode = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={cn(iconStyles(props))}
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="m17.124 5.347 3.463 6.784s.729 1.497.156 2.512l-3.982 7.043a2.11 2.11 0 0 1-2.874.797L4.11 16.956a2.106 2.106 0 0 1-.798-2.873L7.293 7.04c.575-1.014 2.232-1.161 2.232-1.161l7.599-.532h0z"
    />
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M15.689 7.884c-1.281-.724-1.511-2.739-.514-4.5.996-1.762 2.842-2.604 4.122-1.88 1.28.724 1.512 2.739.515 4.501M10.18 9.206l-2.72 4.812M13.624 11.153l-5.313 1.361M11.068 16.057l-.283-4.177M13.201 17.262l1.916-3.389M16.872 15.172s-1.886-1.066-2.636.259"
    />
  </svg>
);
